// extracted by mini-css-extract-plugin
module.exports = {"container":"_slug__container__UVQBX","isDesktop":"_slug__isDesktop__W9rzU","isMobile":"_slug__isMobile__4gGu4"};